import fetch from '@/utils/fetch'
import {
  shop_url
} from '@/global'

/* 获取分组列表 */
export const getGropuList = (companyId) => {
  return fetch({
    url: `${shop_url}/shop/group/list/${companyId}`,
    method: 'get'
  })
}
/* 添加分组 */
export const addGropu = (data) => {
  return fetch({
    url: `${shop_url}/shop/group/add`,
    method: 'post',
    data
  })
}

/* 删除分组 */
export const delGropu = (groupId) => {
  return fetch({
    url: `${shop_url}/shop/group/del/${groupId}`,
    method: 'put'
  })
}

/* 添加分组用餐时间 type为早(1)中(2)晚(3)宵夜(4) */
export const addGroupTime = (data) => {
  return fetch({
    url: `${shop_url}/shop/group/time/add`,
    method: 'post',
    data
  })
}

/* 查询分组用户 */
export const getGroupUser = (data) => {
  return fetch({
    url: `${shop_url}/shop/group/user/list`,
    method: 'post',
    data
  })
}

/* 添加分组用户 */
export const addGroupUser = (data) => {
  return fetch({
    url: `${shop_url}/shop/group/user/add`,
    method: 'post',
    data
  })
}

/* 删除分组用户 */
export const delGroupUser = (data) => {
  return fetch({
    url: `${shop_url}/shop/group/user/del`,
    method: 'post',
    data
  })
}
export const getCompanyUser = (data) => {
  return fetch({
    url: `${shop_url}/shop/group/mobile/info/${data.phone}/${data.companyId}`,
    method: 'post'
  })
}

/* 导入分组用户 */
export const importGroupUser = (groupId, data) => {
  return fetch({
    url: `${shop_url}/shop/meals/group/user/import/${groupId}`,
    method: 'post',
    data
  })
}
